import React, { useState } from 'react';
import { Pagination } from 'antd';
import SelectList from '../Common/SelectList'
import ManageMemberTable from '../Common/ManageMemberTable'
import ConvertButtons from './../Common/ConvertButtons';

const MembershipModify = () => {
   const MemberInfo = [
      {
         SNo: 1,
         Plan: "startup(2334 Days)",
         MaxBranch: 1,
         MaxMember: 50,
         Amount: 0,
         Type: "First Time",
         RegDate: "23-03-2022",
         StartDate: "23-03-2022",
         ExpireDate: "05-12-2025",
         Remarks: "free",
         Status: "Not Expired"
      },
   ];

   const [data, setData] = useState(MemberInfo);
   const [page, setPage] = useState(1);
   const [postPerPage, setPostPerPage] = useState(10);
   const dataRef = React.createRef();

   const itemRender = (current, type, originalElement) => {
      if (type === 'prev') {
         return <a>Previous</a>;
      } else if (type === 'next') {
         return <a>Next</a>;
      }
      return originalElement;
   };

   const indexOfLastPage = page * postPerPage;
   const indexOfFirstPage = indexOfLastPage - postPerPage;
   const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

   return (
      <div className="px-4 xsm:px-8 py-3">
         <div className='w-full '>
            <div className="flex justify-center py-4 font-semibold text-lg sm:text-xl">Membership Details</div>

            <div className='flex sm:justify-between justify-center items-center flex-wrap py-4 '>
               <div className='flex mt-3 mb-4'>
                  <SelectList
                     setPostPerPage={setPostPerPage}
                     data={data}
                  />
               </div>

               <div className='flex mt-3 '>
                  <ConvertButtons
                     data={data}
                     ref={dataRef}
                  />
               </div>
            </div>

            {/* table start */}

            <ManageMemberTable
               data={currentPost}
               ref={dataRef}
            />

            {/* table end */}

            <div className='py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
               <p className='text-sm text-gray-800'>
                  showing {page} to {currentPost.length} of {data.length} entries
               </p>

               <Pagination
                  total={data.length}
                  onChange={value => setPage(value)}
                  itemRender={itemRender}
                  pageSize={postPerPage}
                  current={page}
               />
            </div>
         </div>
      </div>
   )
}

export default MembershipModify
